import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Form } from 'components/shared/Form/Form'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'

import { NON_FIELD_ERRORS, getApiError } from 'utils/apiErrors'
import {
  POSITION_FIELD,
  DEPARTMENT_FIELD,
  LANGUAGES_FIELD,
  DESCRIPTION_FIELD,
  AMOUNT_FIELD,
  getFields,
} from './model'

import styles from './Details.module.scss'

export const Details = ({
  control,
  formState,
  projects,
  watch,
  isPositionManagement,
}) => {
  const fields = getFields({ projects })

  const getFormElement = ({
    field,
    label,
    name,
    placeholder,
    ...restProps
  }) => (
    <Form.Field
      count={watch(name)?.length}
      error={
        (name === POSITION_FIELD &&
          getApiError(formState.errors?.root?.apiError, NON_FIELD_ERRORS)) ||
        formState.errors[name]?.message
      }
      key={name}
      {...{ control, field, label, name, placeholder, ...restProps }}
    />
  )

  const isFormDataInvalid = !formState.isValid && formState.isSubmitted

  return (
    <Box className={styles.details} direction="column">
      <MessageAlert
        className={styles.alert}
        message={t`Please enter all required information to save this job.`}
        variant="error"
        isInitialised={isFormDataInvalid}
      />
      <Box className={styles.fields} direction="column">
        <Box className={styles.horizontalFields} direction="row">
          {getFormElement(fields[POSITION_FIELD])}
          {getFormElement(fields[DEPARTMENT_FIELD])}
        </Box>
        <Box className={styles.horizontalFields} direction="row">
          {getFormElement(fields[LANGUAGES_FIELD])}
          {isPositionManagement && (
            <div className={styles.amountField}>
              {getFormElement(fields[AMOUNT_FIELD])}
            </div>
          )}
        </Box>
        {getFormElement(fields[DESCRIPTION_FIELD])}
      </Box>
    </Box>
  )
}
